const banedStates = ['CA','ID','OR'].map(state => state.toLowerCase());
const banedCBDStates = ['CA','ID','OR'].map(state => state.toLowerCase());
const banedTHCFlowerStates = ['AL','AR' ,'CO' ,'MN','HI','RI','UT' , 'WA'].map(state => state.toLowerCase());

var localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
const manage_california_products = () => {
  localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
  let href = window.location.href;
  if (banedStates.includes(localStorage_state)) {
    document.querySelector('body')?.classList.add('ca-user');
    document.querySelector('body')?.classList.remove('thca-banned-state');
    if (banedCBDStates.includes(localStorage_state)) {
      document.querySelector('body')?.classList.add('cbd-state');
    } else {
      document.querySelector('body')?.classList.remove('cbd-state');
    }
    setTimeout(() => {
      manageSections('hide');
    }, 500);
    if (href.includes('/all')) {
      window.location.href = '/collections/california-state-gate'      
    }else if(href.includes('/pages/quiz')){
      window.location.href = '/'
    }
    
    document.querySelectorAll('[href="/collections/all"]').forEach((ele)=>{
      ele?.setAttribute('href','/collections/california-state-gate')
    });
  }else if(banedTHCFlowerStates.includes(localStorage_state)){
    document.querySelector('body')?.classList.remove('ca-user','cbd-state');
    document.querySelector('body')?.classList.add('thca-banned-state');
    setTimeout(() => {
      manageSections('unhide');
    }, 500);
    document.querySelectorAll('[href="/collections/california-state-gate"]').forEach((ele)=>{
      ele?.setAttribute('href','/collections/all')
    });
  }else{
    if (href.includes('/california-state-gate')) {
      window.location.href = '/collections/all'      
    }
    document.querySelector('body')?.classList.remove('ca-user','cbd-state','thca-banned-state');
    manageSections('unhide');
    document.querySelectorAll('[href="/collections/california-state-gate"]').forEach((ele)=>{
      ele?.setAttribute('href','/collections/all')
    });
  }
  if (!localStorage_state) {
    window.isPageLoad = false;
  }
}

const manageSections = (hide) => {
  try {
    // Manage Tabinations
    document.querySelectorAll('custom-tabs .tabcontent').forEach((ele)=>{
      let customTabs = ele.closest('custom-tabs')
      let tabContent = ele.querySelector('slider-element');
      let nonCaliforniaProducts = tabContent?.querySelectorAll('[data-california-product="false"]') || [];
      let allProducts = tabContent?.querySelectorAll('[data-product-grid]') || [];
      if (allProducts.length > 0 && allProducts.length == nonCaliforniaProducts.length) {
        let tabContentId = ele.getAttribute('id');
        if (tabContentId) {
          if (hide == 'hide') {
            customTabs.querySelector(`[data-tabcontent="#${tabContentId}"]`)?.closest('li')?.classList.add('d-none');
            let openedHiddenLink =  document.querySelector('custom-tabs .tablink:not(.d-none)');
            if (!openedHiddenLink?.classList.contains('open')) {
              openedHiddenLink?.click();
            }
          }else if(hide == 'unhide'){
            customTabs.querySelector(`[data-tabcontent="#${tabContentId}"]`)?.closest('li')?.classList.remove('d-none');
          }
        }
      }
    });
  
    // Manage lab test result page
    document.querySelectorAll('[data-section-scroll]')?.forEach((ele)=>{
      let allProducts = ele.querySelectorAll('[data-product-grid]');
      let nonCaliforniaProducts = ele.querySelectorAll('[data-california-product="false"]');
      if (allProducts.length > 0 && allProducts.length == nonCaliforniaProducts.length) {
        let tabContentId = ele.getAttribute('id');
        if (hide == 'hide') {
          document.querySelector(`.stickybar_wrapper [data-scroll-to="${tabContentId}"]`)?.closest('li')?.classList.add('d-none');
          ele?.classList.add('d-none');
        }else{
          document.querySelector(`.stickybar_wrapper [data-scroll-to="${tabContentId}"]`)?.closest('li')?.classList.remove('d-none');
          ele?.classList.remove('d-none');
        }
      }
    })
  
    // Remove blank sections
    document.querySelectorAll('[data-section-id]').forEach((ele)=>{
      let allProducts = ele.querySelectorAll('[data-product-grid]');
      let nonCaliforniaProducts = ele.querySelectorAll('[data-california-product="false"]');
      if (allProducts.length > 0 && allProducts.length == nonCaliforniaProducts.length) {
        if (hide == 'hide') {
          ele?.classList.add('d-none');
        }else{
          ele?.classList.remove('d-none');
        }
      }
    });
  
    // Manage collection page
    const productGrid = document.querySelector('#product-grids');
    if (productGrid) {
      const noSearchEle = document.querySelector('[data-no-search]')
      let allProducts = productGrid?.querySelectorAll('[data-product-grid]') || [];
      let nonCaliforniaProducts = productGrid?.querySelectorAll('[data-california-product="false"]') || [];
      const filterBarEle = document.querySelector('[data-filter-bar]')
      if (allProducts && nonCaliforniaProducts && allProducts.length > 0 && allProducts.length == nonCaliforniaProducts.length) {
        if (hide == 'hide') {
          noSearchEle?.classList.remove('d-none');
          filterBarEle?.classList.add('d-none');
        }else{
          noSearchEle?.classList.add('d-none');
          filterBarEle?.classList.remove('d-none');
        }
      }
    }

    // Manage Collection List Section
    document.querySelectorAll('.collections-list').forEach((ele)=>{
      if (hide == 'hide') {
        ele?.classList.add('d-none');
      }else{
        ele?.classList.remove('d-none');
      }
    })

    //Manage Attributes after few delay
    setTimeout(() => {

      document.querySelectorAll('[data-california-element-delay]').forEach((ele)=>{
        let is_california = ele.getAttribute('data-california-element-delay');
        ele.removeAttribute('data-california-element-delay');
        ele.setAttribute('data-california-element',is_california);
      })
    }, 1000);
  }catch(err){
    console.log(err,'<=== Error')
  }
}

const _selectProvince = (stateCode = localStorage_state) => {
  if (!stateCode) return;
  document.querySelector(`[data-country-code="${stateCode.toUpperCase()}"]`)?.click();
  document.querySelector('[data-confirm-province]')?.click();
}

// Expose globally
window._selectProvince = _selectProvince;
window.manage_california_products = manage_california_products;

const provinceSelectorDropdown = document.querySelector('[data-province-dropdown]');
document.querySelectorAll('[data-country-code]').forEach((ele)=>{
  ele.addEventListener('click',(event)=>{
    event.preventDefault();
    event.stopPropagation();
    let text = ele.innerText;
    if (document.querySelector('[data-province-selector]')) {
      document.querySelector('[data-province-selector]').value = text;
    }
    if (document.querySelector('[data-selected-state]')) {
      document.querySelector('[data-selected-state]').innerHTML = text;
    }
    document.querySelector('[data-province-selector]')?.setAttribute('data-country-code',ele.getAttribute('data-country-code'))
    provinceSelectorDropdown?.classList.add('d-none');
  })
});

window.isPageLoad = true;
document.querySelector('[data-confirm-province]')?.addEventListener('click',()=>{
  let code = document.querySelector('[data-province-selector]')?.getAttribute('data-country-code')
  document.querySelector('[data-default-option]')?.classList.add('d-none');
  document.querySelector('[data-selected-option]')?.classList.remove('d-none');
  setTimeout(() => {
    document.body?.classList.remove('statelist-dropdown');
  }, 500);
  document.querySelector('site-overlay')?.classList.remove('overlay--body');
  const selectedOptionState = document.querySelector('[data-selected-option] .state');
  if (selectedOptionState) {
    selectedOptionState.innerHTML = code;
  }
  localStorage.setItem('user_location',code);
  Utility.toggleElement(document.querySelector('.state-dropdown .custom--select'), 'close');
  manage_california_products();
  document.querySelector('body')?.classList.remove('state-mobile-dropdown');
  window.isPageLoad = false;
  try{
    if (window.isPageLoad == false) {
      heatmap_triggers();
    }
  }catch(err){
    console.log('Heatmap errors=> ', err)
  }
})

function heatmap_triggers() {
  let localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
  let variant_friendly_name = localStorage_state === 'ca' ? "California" : "Default";

  // Trigger Heatmap Event
  try{
    window._heatmap_custom_event_tag({
      partner: "state_gate",
      partner_friendly_name: "State Gate",
      type: "custom_ab_test",
      variant_friendly_name: variant_friendly_name,
    });
    // Update the URL with the new query parameter
    Utility.updateQueryParam('heatmap_state_gate', variant_friendly_name);
  }catch(err){
    console.log('Heatmap errors=> ', err)
  }
}

// Close button click event
document.querySelector('.state-dropdown .custom--select .state-close')?.addEventListener('click', () => {
    Utility.toggleElement(document.querySelector('.state-dropdown .custom--select'), 'close');
    if (window.innerWidth <= 575) {
        siteOverlay.prototype.hideOverlay();
    }

    // Remove `scroll-fixed` and `state-dropdown` classes from the body
    document.body.classList.remove('scroll-fixed', 'state-mobile-dropdown');
})

// document.addEventListener('click',(event)=>{
//   let target = event.target;
//   if (!target.closest('[data-select-state]')) {
//     provinceSelectorDropdown?.classList.add('d-none');
//   }
// })

document.querySelector('[data-province-selector]')?.addEventListener('click', (event) => {
    let ele = event.target
    let code = ele.getAttribute('data-country-code');
    const provinceElement = document.querySelector(`[data-province-dropdown] [data-country-code="${code}"]`);
    if (!provinceElement) return;
    let name = provinceElement.innerText;
    ele.setAttribute('placeholder', name.trim())
    ele.value = "";
    provinceSelectorDropdown?.classList.remove('d-none');
    const provinceItems = document.querySelectorAll('.city li:not([data-no-result])');
    provinceItems.forEach(item => {
        item.style.display = '';
    });
})
document.querySelector('[data-province-selector]')?.addEventListener('input', function (event) {
    provinceSelectorDropdown?.classList.remove('d-none');

    const query = event.target.value.toLowerCase();
    const provinceItems = document.querySelectorAll('.city li:not([data-no-result])');
    let hasMatch = false;

    provinceItems.forEach(item => {
        const provinceName = item.textContent.toLowerCase();
        if (provinceName.includes(query)) {
            item.style.display = '';
            hasMatch = true;
        } else {
            item.style.display = 'none';
        }
    });

    const noResultItem = document.querySelector('[data-no-result]');
    if (hasMatch) {
        noResultItem.classList.add('d-none');
    } else {
        noResultItem.classList.remove('d-none');
    }
});


(async () => {
    try {

        // Store location in localStorage if not already set

        if (!localStorage.getItem('user_location')) {
            // Wait until the user's location is fetched
            window.userLocation = await Utility.getIPInfo();
                    if (window.userLocation != false) {
            let currentprovinceCode = window.userLocation?.provinceCode;
            if (currentprovinceCode) {
                document.querySelector(`[data-country-code="${currentprovinceCode}"]`)?.click();
                // localStorage.setItem('user_location', currentprovinceCode);
            }
        }
        }

        // Now get localStorage state after ensuring data is available
        localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
        // Start executing all dependent functions
        manage_california_products();

        if (localStorage_state) {
            _selectProvince();
        } else {
            setTimeout(() => {
                document.querySelector('.state-dropdown .default')?.click();
            }, 500);
            _forceSelectProvince(true)
        }

    } catch (error) {
        console.error("Error fetching user location:", error);
    }
})();

function _forceSelectProvince(isForce) {
    if (isForce) {
        document.body?.classList.add('statelist-dropdown');
        document.querySelector('site-overlay')?.classList.add('overlay--body');
    } else {
        document.body?.classList.remove('statelist-dropdown');
        document.querySelector('site-overlay')?.classList.remove('overlay--body');
    }
}

// let manageStatePopupVisibility = () => {
//   let popupIds = ["7adb4d81e7ee11ef8d1cf5407278c646","7adb4d80e7ee11ef8d1cf5407278c646"];
//   popupIds.forEach((id)=>{
//     const iframe = document.querySelector(`[id*="-${id}"]`);
//     if (iframe) {
//       _forceSelectProvince(false);
//       Utility.toggleElement(document.querySelector('.state-dropdown .custom--select'), 'close');
//     }
//   })
// }
// setInterval(()=>{
//   manageStatePopupVisibility();
// },100)